/**
 *    __ _ _      _
 *  / _(_) |_   (_)___
 * | |_| | __|  | / __|
 * |  _| | |_ _ | \__ \
 * |_| |_|\__(_)/ |___/
 *            |__/
 * @ScriptName  : fit.js
 * @Version     : 1.0.3
 * @Author      : masahiro.imanaka / naoki.umeyama
 * @copyright   : mixi, Inc. All Rights Reserved.
 * @Description :
 *
 * fit.jsは、固定幅で作成したコンテンツを、端末画面幅にあわせてzoomすることで画面幅にフィットさせるライブラリです。
 * コンテンツを可変させることを前提としたレスポンシブデザインとは全く違う思想で、レスポンシブデザインを実現します。
 * Chrome・Safariはzoom、FirefoxとIEはcss3のtransformで、画面幅にあわせ拡大します。
 *
 * ＜使い方＞
 * fitさせたいコンテンツを下記のDOM構造で記述します。
 * ------------------------------------------------------------
 * 	通常
 * ------------------------------------------------------------
 * 	<div class="js-fit">
 * 		<div class="js-fit-zoom">
 * 			fitさせたいコンテンツ
 * 		</div>
 * 	</div>
 *
 * ------------------------------------------------------------
 * 	position:fixed の要素
 * ------------------------------------------------------------
 * 	<div class="js-fit-fixed">
 * 		<div class="js-fit-zoom-fixed">
 * 			fitさせたい position: fixed; のコンテンツ
 * 		</div>
 * 	</div>
 *
 * ------------------------------------------------------------
 *
 * その他、注意点として、fit.jsの対象のDOMの範囲内に、
 * 下記の要素がある場合、特別な対応が必要となります。
 *
 *	- position:fixed; の要素
 *	- iframe要素(Twitter,FBのWidet等も含む)
 *	- 画面内のoffset値（アンカー処理等）
 *
 */


(function(){
	Fit = FitContents = window.Fit || {

		// 案件によって、変更しても問題ない場所
		options: {
			// PCとSPではコンテンツをフィットさせる端末幅が変わるため、
			// 端末ごとの横幅の範囲（min〜max）をを指定する
			resizeData: [
				{
					min: 320,
					max: 737,
					contentWidth: 320,
					mode: "sp"
				},
				{
					min: 737,
					max: 1200,
					contentWidth: 1200,
					mode: "pc"
				}
			],

			// 処理対象セレクタの指定
			selector: {
				normal: {
					contents: '.js-fit',
					zoom: '.js-fit-zoom'
				},
				fixed: {
					contents: '.js-fit-fixed',
					zoom: '.js-fit-zoom-fixed'
				}
			}
		},

		// Chrome・Safari用
		_ZOOM: "zoom",

		// Firefox・IE用
		_TRANSFORM: "transform",

		// 拡大処理にCSSのどちらのプロパティを利用しているか
		type: {
			isZoom: null,
			isTransform: null
		},

		// アクセスしている端末のUserAgent
		ua: null,

		// zoom or transform を格納
		_styleProperty: null,

		// SP判定
		isSP: null,

		// 画面横幅
		htmlWidth: 0,
		// 画面高さ
		htmlHeight: 0,
		// 拡大率
		zoomScale: 1,

		// sp or pc が設定される
		mode: null,

		// レイアウト変更（modeがpcからspに変更等）のフラグ ※Facebookのウィジェットをパースさせ直すためのフラグとして使える
		isLayoutChange: true,
		// スケール変更時のフラグ
		isScaleChange: true,
		// ウィンドウ幅変更時のフラグ
		// isWidthChange: true,

		_dataIndex: 0,

		// 現在のウィンドウ幅
		windowWidth: 0,
		// リサイズ前のウィンドウ幅
		prevWindowWidth: 0,

		// 最大幅・最小幅を格納するためのオブジェクト
		_applyWidth: {},

		// Fit.Coreを格納するための配列
		_instance:[],

		// SNSプラグインが存在するかのフラグ
		_isSnsWidget: {
			twitterTimeline: false,
			facebookPageWidget: false,
			tweetBtn: false,
			facebookBtn: false,
			lineBtn: false
		},

		/**
		 * Fitで使用するDOMを明示する場所
		 */
		ui: {},


		/**
		 * 初期化処理
		 * @method initialize
		 */
		initialize: function() {
			this.overwriteOptions();
			var layer = [];
			layer[0] = new this.Normal();
			layer[1] = new this.Fixed();
			this.bindUIElements();
			this.initSetting();
			this.Main();

			// アンカー遷移先がズレる問題の解消
			if( location.hash != "" )
			{
				var target = document.getElementById( location.hash.replace( /#/ , "" ) ) ;
				if( target )
				{
					window.requestAnimationFrame( function( )
						{
							var top = Fit.getOffsetTop( target ) ;
							top = top * Fit.zoomScale ;

							window.scrollTo( 0 , top ) ;
						} ) ;
				}
			}
		},


		/**
		 * fit.jsの処理対象となる画面上のUIを取得する処理
		 *
		 * @method bindUIElements
		 */
		bindUIElements: function(){
			this.ui.html = document.documentElement;
			this.ui.loaded = document.getElementsByClassName("js-fit-loaded");
		},


		/**
		 * アクセス端末のユーザーエジェントを返却する処理
		 *
		 * @method getUserAgent
		 * @return { String } UAの文字列
		 */
		getUserAgent: function() {
			return navigator.userAgent.toLowerCase();
		},


		/**
		 * ユーザーエジェントにあわせた、
		 * 拡大処理に利用するcssのプロパティを返却する処理
		 *
		 * @param { String } useragent ユーザエージェントを引数に受ける
		 * @method getZoomStyleProperty
		 * @return { String } stylepropaty "zoom" or "transform"
		 */
		getZoomStyleProperty: function(useragent) {
			var stylepropaty;
			if(/msie|trident|firefox/.test(useragent)) {
				stylepropaty = this._TRANSFORM;
			} else {
				stylepropaty = this._ZOOM;
			}
			return stylepropaty;
		},


		/**
		 * アクセス端末がスマートフォンか判定して返却する処理
		 *
		 * @param { String } useragent ユーザエージェントを引数に受ける
		 * @method checkSP
		 * @return { Boolean } true or false
		 */
		checkSP: function(useragent) {
			return /iphone;|ipod;/.test(useragent) || (/android/.test(useragent) && ! !/mobile/.test(useragent));
		},


		/**
		 * fit.options:{}を上書きする処理
		 * html側にオプションの上書き指定がある場合はそちらを利用する
		 *
		 * Object.assign(); や jQueryの$.extend();のように
		 * Objectをマージするものではない点に注意してください。
		 * (Object.assingnはIE未対応、$.extendはjQuery非依存のため利用しない）
		 *
		 * @method overwriteOptions
		 */
		overwriteOptions: function() {
			if (app && app.init && app.init.fit) {
				if(app.init.fit.resizeData) {
					this.options.resizeData = app.init.fit.resizeData;
				}
				if(app.init.fit.selector) {
					this.options.selector = app.init.fit.selector;
				}
			}
		},


		/**
		 * 必要な設定の初期反映
		 *
		 * @method InitSetting
		 */
		initSetting: function(){
			// Fitの処理に必要な各種初期値を取得して設定
			this.ua = this.getUserAgent();
			this._styleProperty = this.getZoomStyleProperty(this.ua);
			this.isSP = this.checkSP(this.ua);
			this._isSnsWidget = this.checkSNSWidget();

			this.type = {
				isZoom: this._styleProperty == this._ZOOM,
				isTransform: this._styleProperty == this._TRANSFORM
			};
			this._applyWidth = {
				min: this.options.resizeData[0].min,
				max: this.options.resizeData[0].max
			};
			for( var i = 1; i < this.options.resizeData.length; i++ ) {
				if( this._applyWidth.min > this.options.resizeData[i].min ){
					this._applyWidth.min = this.options.resizeData[i].min;
				}
				if( this._applyWidth.max < this.options.resizeData[i].max ){
					this._applyWidth.max = this.options.resizeData[i].max;
				}
			};
		},

		/**
		 * fit.jsのメイン処理
		 *
		 * @method  Fit
		 */
		Main: function(){
			var _this = this;

			/**
			 * リサイズ時に実行する処理
			 *
			 * @method onResize
			 */
			var onResize = this.onResize = function() {
				// ウィンドウ幅を元にブレイクポイントを選定
				var prevIndex = _this._dataIndex ;
				var settingScale ;

				_this.htmlWidth = _this.ui.html.offsetWidth;
				_this.htmlHeight = _this.ui.html.offsetHeight;

				_this.windowWidth = _this.htmlWidth ;
				_this._dataIndex = 0 ;


				// ズーム値を決定
				if( _this.windowWidth < _this._applyWidth.min )
				{
					// レスポンシブ範囲以下のフィットは計算で出す
					_this._dataIndex = 0 ;
					_this.data = _this.options.resizeData[ _this._dataIndex ] ;
					settingScale = _this._applyWidth.min / _this.data.contentWidth ;
					_this.mode = _this.data.mode ;
				}
				else if( _this.windowWidth >= _this._applyWidth.max )
				{
					// レスポンシブ範囲以上はフィット値をリセット
					_this._dataIndex = _this.options.resizeData.length-1 ;
					_this.data = null ;
					settingScale = 1 ;
					_this.mode = null ;
				}
				else
				{
					// レスポンシブ範囲内のフィットは計算で出す
					for( i = 0 ; i < _this.options.resizeData.length ; i++ )
					{
						var temp = _this.options.resizeData[i] ;
						if( temp.min <= _this.windowWidth && _this.windowWidth < temp.max )		break ;
					}

					_this._dataIndex = i ;
					_this.data = _this.options.resizeData[ _this._dataIndex ] ;
					settingScale = _this.htmlWidth / _this.data.contentWidth ;
					_this.mode = _this.data.mode ;
				}


				// 各挙動フラグを取得
				_this.isLayoutChange = prevIndex != _this._dataIndex ;
				_this.isScaleChange = _this.zoomScale != settingScale ;
				// _this.isWidthChange = _this.prevWindowWidth == _this.windowWidth ;
				_this.zoomScale = settingScale ;

				//	 	-	 	-	 	-	 	-	 	-	 	-	 	-	 	-	 	-	 	-

				for( i = 0 ; i < onResizeTask.length ; i++ )
				{
					onResizeTask[i]( ) ;
				}
				_this.prevWindowWidth = _this.windowWidth ;

				//

				_this.fit( ) ;

				// 画面リサイズの際に、twitterTimelineWidgetとFacebbookPageWidgetがあれば再調整する
				_this.twitterTimelineWidget.readjust();
				_this.facebookPageWidget.readjust();
				_this.tweetBtn.readjust();
				_this.facebookBtn.readjust();
				_this.lineBtn.readjust();
			}

			var onResizeTask = [];
			this.onResize.add = function(taskFunc){
				onResizeTask.push(taskFunc) ;
			}

			/**
			 * ページをフィットさせる処理
			 *
			 * @method fit
			 */
			this.fit = function() {
				for( i = 0 ; i < _this._instance.length ; i++ ) {
					_this._instance[i].fit( _this.data ) ;
				}
			}

			window.requestAnimationFrame(
				function() {
					onResize();
					window.addEventListener( "resize" , onResize ) ;

					if (_this.ui.loaded[0]){
						_this.ui.loaded[0].style.display = 'none';
					}
					for (var i = 0; i < Fit._instance.length; i++) {
						for (var j = 0; j < Fit._instance[i].container.length; j++) {
							if (Fit._instance[i].container[j]){
								Fit._instance[i].container[j].style.opacity = 1;
							}
						}
					}

				}
			);

			//yoshida editing
			onResize();

		},


		/**
		 * Fitのメインロジック
		 * 処理の対象のセレクタに対して、style指定
		 *
		 * @param {String} type 標準Fit（引数なし）か固定Fit（fixed）かの指定
		 * @method Core
		 */
		Core: function(type) {
			Fit._instance.push(this);
			var contents_selector,zoom_selector;
			if(type === 'fixed'){
				contents_selector = Fit.options.selector.fixed.contents;
				zoom_selector = Fit.options.selector.fixed.zoom;
			}else{
				contents_selector = Fit.options.selector.normal.contents;
				zoom_selector = Fit.options.selector.normal.zoom;
			}

			var container = this.container = document.querySelectorAll(contents_selector);
			for (var i = 0; i < container.length; i++) {
				container[i].setAttribute('style', [
					'top: 0;',
					'left: 0;',
					'width: 100%;',
					'overflow: hidden;',
					'min-width: ' + Fit.options.resizeData[0].min + 'px;'
				].join(''));

				var zindex = container[i].getAttribute('data-zindex');
				if(zindex){
					container[i].style.zIndex = zindex;
				}

			}

			var zoom = this.zoom = document.querySelectorAll(zoom_selector);
			for (var i = 0; i < zoom.length; i++) {
				zoom[i].setAttribute('style', [
					'overflow: hidden;',
					'transform-origin: 0 0;'
				].join(''));
			}
		},

		/**
		 * デフォルトの場合のFit処理
		 *
		 * @method Normal
		 */
		Normal: function() {
			var obj = new Fit.Core();
			obj.fit = Fit.fitStyleType(obj.zoom, Fit.offsetHeight);
		},

		/**
		 * fixed要素に対するFit処理
		 *
		 * @method Fixed
		 */
		Fixed: function(){
			var obj = new Fit.Core('fixed');
			var container = obj.container;
			var zoom = obj.zoom;

			for (var i = 0; i < container.length; i++) {
				container[i].style.position = "fixed";
				container[i].style.height = "100%";
				container[i].style.pointerEvents = "none";
			}
			for (var i = 0; i < zoom.length; i++) {
				zoom[i].style.height = "100%";
			}
			obj.fit = Fit.fitStyleType(zoom, Fit.htmlHeight);
		},


		/**
		 * absolute要素に対するFit処理
		 *
		 * @param {String} selector 正規表現形式の処理対象の要素のセレクタ
		 * @param {[type]} parentNode
		 * @method Absolute
		 */
		Absolute: function(){
			var obj = new Fit.Normal();
			var container = obj.container;
			var zoom = obj.zoom ;
			for (var i = 0; i < container.length; i++) {
				container[i].setAttribute('style', [
					'position: absolute;',
					'left: 0;',
					'top: 0;'
				].join(''));
			}
		},


		/**
		 * fitStyleType
		 *
		 * @param {Object} selector html object
		 * @method fitStyleType
		 */
		fitStyleType: function( selector, height ) {
			return function (data){
				switch (Fit._styleProperty) {
					case Fit._ZOOM:
						for (var i = 0; i < selector.length; i++) {
							selector[i].style.zoom = Fit.zoomScale;
						}
						break;
					case Fit._TRANSFORM:
						for (var i = 0; i < selector.length; i++) {
							selector[i].style.width = data ? data.contentWidth + "px" : "" ;
							selector[i].style.transform = "scale(" + Fit.zoomScale + ")" ;
							if(height !== 0){
								selector[i].style.height = ( height / Fit.zoomScale ) + "px";
							}

							var container = selector[i].parentNode ;
							if( !/js\-fit\-fixed/.test(container.className) )
							{
								selector[i].parentNode.style.height = ( selector[i].offsetHeight * Fit.zoomScale ) + "px" ;
							}
							else
							{
								selector[i].style.height = ( selector[i].parentNode.offsetHeight / Fit.zoomScale ) + "px" ;
							}
						}
						break;
				}
			}
		},


		/**
		 * 画面内に各SNSウィジェットが存在するかチェック
		 *
		 * @param {Object} selector html object
		 * @method checkSNSWidget
		 */
		checkSNSWidget: function(selector) {
			return {
				twitterTimeline: this.hasClass('.twitter-timeline'),
				facebookPageWidget: this.hasClass('.fb-page'),
				tweetBtn: this.hasClass('.twitter-share-button'),
				facebookBtn: this.hasClass('.fb-like'),
				lineBtn: this.hasClass('.line-it-button')
			}
		},

		/**
		 * 対象クラスが存在するかをチェック
		 * @param  {Object}  selector htmlオブジェクト
		 * @return {Boolean} true, false
		 * @method hasClass
		 */
		hasClass: function(selector){
			var selector = document.querySelectorAll(selector);
			var hasflg;
			if (selector.length){
				hasflg = true;
			} else {
				hasflg = false;
			}
			return hasflg;
		},

		/**
		 * TwitterのタイムラインWidgetの高さをfit.jsに対応させる処理
		 * .twitter-timelineがある場合のみ処理。Widgetが取得できるまで0.5秒おきに呼ぶ。
		 *
		 * @method twitterTimelineWidget
		 */
		twitterTimelineWidget: {
			selector: null,
			readjust: function() {
				if(Fit._isSnsWidget.twitterTimeline) {
					Fit.twitterTimelineWidget.selector = document.querySelectorAll('iframe.twitter-timeline');
					if(Fit.twitterTimelineWidget.selector.length) {
						for (var i = 0; i < Fit.twitterTimelineWidget.selector.length; i++) {
							if(!Fit.twitterTimelineWidget.selector[i] || Fit.twitterTimelineWidget.selector[i].style.height === '0px') {
								setTimeout( Fit.twitterTimelineWidget.readjust , 500 ) ;
								return;
							}
							Fit.twitterTimelineWidget.selector[i].style.height = Fit.zoomScale * 100 + "%";
						}
					} else {
						setTimeout( Fit.twitterTimelineWidget.readjust , 500 ) ;
					}
				}
			}
		},

		/**
		 * Facebook Page Widgetがある場合にfit.jsに対応させる処理
		 *
		 * - .fb-page がある場合のみ処理。
		 * - .fb-pageがある場合のみ処理。
		 *
		 * @method facebookPageWidget
		 */
		facebookPageWidget: {
			timer: null,
			isFirstParse: true,
			isXfbmlParse: true,

			/**
			 * Facebook Page Widget（.fb-page iframe） が読込完了しているかチェックする処理
			 * 読込が完了していない場合、1000ms後に再チェックする
			 *
			 * @param  {Object} target HTML Obbject
			 * @return {undefined}
			 * @method checkImport
			 */
			checkImport: function(target) {
				// console.log(target);
				if(target.length === 0) {
					setTimeout( Fit.facebookPageWidget.readjust , 1000 ) ;
					return;
				}
			},

			/**
			 * Facebook Page Widgetが書き込みが完了しているかチェックする処理
			 * 書き込みが完了していない場合、1000ms後に再チェックする
			 *
			 * @param  {Object} target HTML Obbject
			 * @return {undefined}
			 * @method checkRender
			 */
			checkRender: function(target) {
				// console.log(Facebook Widetの状態を確認し、読込が完了していなければ1000ms後に再チェック（実行）する);
				if(!target || !target.style || !target.style.height === '0px') {
					// console.log('まだFacebook WidetのDOMがみつからない状態');
					setTimeout( Fit.facebookPageWidget.readjust , 1000 ) ;
					return;
				}
			},

			/**
			 * Facebook Widet の数だけ、
			 * Fit.js対応用のCSSを適用させる処理
			 *
			 * @param  {Object} target HTML Obbject
			 * @method addReadjustStyle
			 */
			addReadjustStyle: function(target) {
				// console.log(Facebook Widet の数だけ再描画処理を実行);
				for (var i = 0; i < target.length; i++) {

					// Facebook Page WidetがRender済か確認
					Fit.facebookPageWidget.checkRender(target[i]);

					// Facebook WidetのRender完了。Fit.js対応用のCSSを適用させる。
					Fit.setStyleTransform(target[i]);
				}
			},

			/**
			 * Facebook Widet をリサイズ時に再調整する処理
			 *
			 * @method readjust
			 */
			readjust: function() {

				if(Fit._isSnsWidget.facebookPageWidget) {
					if(Fit.facebookPageWidget.isFirstParse) {
						// Facebook Page Widet の初期パース（レンダリング）の場合
						var fbpage_iframe = document.querySelectorAll('.fb-page iframe');
						Fit.facebookPageWidget.checkImport(fbpage_iframe);
						Fit.facebookPageWidget.addReadjustStyle(fbpage_iframe);
						Fit.facebookPageWidget.isFirstParse = false;
					} else {
						// リサイズイベントが実行された後、1000ms後に処理を開始
						clearTimeout(Fit.facebookPageWidget.timer);
						Fit.facebookPageWidget.timer = setTimeout(function() {

							if (Fit.facebookPageWidget.isXfbmlParse){
								Fit.facebookPageWidget.isXfbmlParse = false;
								// window.FB.XFBML.parse();
								window.FB.XFBML.parse(document.getElementById('sns'));

							}
							var fbpage_iframe = document.querySelectorAll('.fb-page iframe');
							Fit.facebookPageWidget.checkImport(fbpage_iframe);
							Fit.facebookPageWidget.addReadjustStyle(fbpage_iframe);
							Fit.facebookPageWidget.isXfbmlParse = true;
						}, 1000);

					}
				}
			}

		},


		/**
		 * 各SNSボタンをfit.jsに対応させる共通処理
		 *
		 * @method btnReadjust
		 */
		btnReadjust: function(target, func, type) {
			if(target.length) {
				for (var i = 0; i < target.length; i++) {
					if(!target[i] || !target[i].style || target[i].style.height === '0px') {
						setTimeout( func , 1000 ) ;
						return;
					}
					// if (Fit.ua.indexOf('ipad') !== -1 || Fit.mode === 'sp'){

					Fit.setStyleTransform(target[i]);
					if(target[i].style.height !== 'auto') {
						setTimeout( func , 1000 ) ;
					}

					// }
				}
			} else {
				setTimeout( func , 1000 ) ;
			}
		},

		/**
		 * tweetbtnをfit.jsに対応させる処理
		 * tweetbtnが反映されるまで0.5秒おきに呼ぶ。
		 *
		 * @method tweetBtn.readjust
		 */
		tweetBtn: {
			timer: null,
			readjust: function() {
				if(Fit._isSnsWidget.tweetBtn) {
					clearTimeout(Fit.tweetBtn.timer);
					Fit.tweetBtn.timer = setTimeout(function() {
						var twitter_iframe = document.querySelectorAll('iframe.twitter-share-button');
						Fit.btnReadjust(twitter_iframe, Fit.tweetBtn.readjust);
					}, 1000);
				}
			}
		},

		/**
		 * facebookbtnをfit.jsに対応させる処理
		 * facebookbtnが反映されるまで0.5秒おきに呼ぶ。
		 *
		 * @method facebookBtn.readjust
		 */
		facebookBtn: {
			timer: null,
			readjust: function() {
				if(Fit._isSnsWidget.facebookBtn) {
					clearTimeout(Fit.facebookBtn.timer);
					Fit.facebookBtn.timer = setTimeout(function() {
						var facebook = document.getElementsByClassName('fb-like');
						var facebook_iframe = facebook[0].getElementsByTagName('iframe');
						Fit.btnReadjust(facebook_iframe, Fit.facebookBtn.readjust);
					}, 1000);
				}
			}
		},

		/**
		 * linebtnをfit.jsに対応させる処理
		 * linebtnが反映されるまで0.5秒おきに呼ぶ。
		 *
		 * @method lineBtn.readjust
		 */
		lineBtn: {
			timer: null,
			readjust: function() {
				if(Fit._isSnsWidget.lineBtn) {
					clearTimeout(Fit.lineBtn.timer);
					Fit.lineBtn.timer = setTimeout(function() {
						var line_iframe = document.getElementsByClassName('line-it-button');
						Fit.btnReadjust(line_iframe, Fit.lineBtn.readjust, 'line');
					}, 1000);
				}
			}
		},


		/**
		 * zoomの効いている要素内のiframeに対してtransformをかけることで表示倍率を調整する処理
		 * @param {[type]} el [description]
		 * @method setStyleTransform
		 */
		setStyleTransform: function(el){
			el.setAttribute('style', [
				'transform: scale(' + Fit.zoomScale + ');',
				'-webkit-transform: scale(' + Fit.zoomScale + ');',
				'-moz-transform: scale(' + Fit.zoomScale + ');',
				'-ms-transform: scale(' + Fit.zoomScale + ');',
				'transform-origin: 0 0;',
				'-webkit-transform-origin: 0 0;',
				'-moz-transform-origin: 0 0;',
				'-ms-transform-origin: 0 0;',
				'width: auto;',
				'height: auto;'
			].join(''));
		},


		/**
		 *
		 * @param target 左上からの位置を取得したい対象のエレメント
		 *        rootTarget 左上を0,0とする対象の親エレメント、デフォルトは<body>タグ
		 */
		getOffsetTop:function( target , rootTarget )
		{
			rootTarget = rootTarget == undefined ? document.body : rootTarget ;
			var top = target.offsetTop ;
			var parent = target.parentNode ;

			while( parent && parent != rootTarget )
			{
				var parentStyle = parent.currentStyle || document.defaultView.getComputedStyle( parent , '' ) ;

				if( parent.offsetTop !== undefined && parentStyle.position != "static" )
				{
					top += parent.offsetTop ;
				}
				parent = parent.parentNode ;
			}

			return top ;
		}
	};


	// requestAnimationFrameを多くのブラウザで利用するための、prefix指定
	window.requestAnimationFrame = window.requestAnimationFrame ||
																 window.webkitRequestAnimationFrame ||
																 window.mozRequestAnimationFrame	||
																 window.msRequestAnimationFrame ||
																 window.oRequestAnimationFrame ||
																 function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	//yoshida editing
	// DOMの準備が完了したら、Fit.initializeを呼ぶ
	if( app && app.init && app.init.fit && app.init.fit.readyFlag ){
		document.readyState === "complete"
			? setTimeout( function(){ Fit.initialize(); } , 1 )
			: document.addEventListener( "DOMContentLoaded", function(){ Fit.initialize(); } ) ;
	}else{
		Fit.initialize();
	}

})();
